import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import PropTypes from "prop-types";

function Authentication({ protectedComponent: ProtectedComponent }) {
  const loginData = useSelector((state) => state.users);

  console.log("logidata", loginData);

  if (loginData.users.clientDetails.fullName) {
    return <ProtectedComponent />;
  } else {
    return <Navigate to="/" />;
  }
}

Authentication.propTypes = {
  protectedComponent: PropTypes.elementType.isRequired, // Utilise elementType pour accepter un composant React
};

export default Authentication;
